import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppToolkitModule } from './app-toolkit.module';
import { AppMaterialModule } from './app-material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { FooterComponent } from './shared/components/footer/footer.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { SubHeaderComponent } from './shared/components/sub-header/sub-header.component';
import { RouterModule } from '@angular/router';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { IConfig, NgxMaskDirective, provideEnvironmentNgxMask } from 'ngx-mask';
import { CommonModule } from '@angular/common';
import { InterceptorModule } from './core/interceptors/interceptor.module';
import { RegistrationService } from './shared/services/registration-service/registration.service';
import {
    RegistrationDialogComponent
} from './registration/components/registration-dialog/registration-dialog.component';
import { LoadingPanelComponent } from './shared/components/loading-panel/loading-panel.component';

export const maskConfigFunction: () => Partial<IConfig> = () => ({
    validation: false,
});

@NgModule({ declarations: [
        AppComponent,
        RegistrationDialogComponent
    ],
    bootstrap: [AppComponent], imports: [CommonModule,
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        AppToolkitModule,
        AppMaterialModule,
        ReactiveFormsModule,
        RouterModule,
        NgxMaskDirective,
        InterceptorModule,
        LoadingPanelComponent,
        SubHeaderComponent,
        FooterComponent,
        HeaderComponent], providers: [
        RegistrationService,
        provideEnvironmentNgxMask(maskConfigFunction),
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {
}
